import "../10. Battle/Library/LibraryBoxBattle.scss";
import Control from "../1. Core/Control";
import NP, {ValueChangedEventArgs} from "../1. Core/NP";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../1. Core/Delegate";
import {ServerAPI} from "../1. Core/ServerAPI";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import JudgesFilterPanel from "./JudgesFilterPanel";

import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import BattlesList from "../10. Battle/Library/Lists/BattlesList";
import Menu from "../1. Core/Controls/Menu/Menu";
import EditJudgeDialog from "./EditJudgeDialog";


export interface IJudge {
	Region: string;
	Id: number,
	FirstName: string,
	LastName: string,
	City: string,
	State: string,
	StateISO: string,
	Rating: number,
	Qualification: string,
	CountryId: number,
	CountryName: string,
	BoutsCount: number
}

export interface IJudgeListItem {
	Judge: IJudge,
	Id: number,
	Name: string,
	City: string,
	State: string,
	StateISO: string,
	Image: string,
	Rating: number,
	Qualification: string,
	BoutsCount: number
}

interface IJudgeFiltersSort {
	FilterText?: string,
	SortField: string,
	SortDirection: number
}

export default class JudgesList extends Control {
	private _Count: number;
	private _Offset: number;
	private _topAppBar: TopAppBar;
	private _FilterText: string;
	private EvShowPageModeClick: Delegate;
	private EvPageModeChanged: Delegate;
	private _Judges: IJudgeListItem[];
	private _dataTable: DataTable;
	private _filtersPanel: JudgesFilterPanel;

	private _dataWithFiltersNode: HTMLElement;

	private _drillDownPanel: BattlesList;
	private _DrillDownMode: boolean;
	private _judjeListNode: HTMLElement;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvShowPageModeClick = new Delegate();
		this.EvPageModeChanged = new Delegate();
		this._FilterText = '';
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();

		this._Count = 100;
		this._Offset = 0;

		this._judjeListNode = NP.createNode(this._root);

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: NP.RM.getString('Refereeing'),
			ParentNode: this._judjeListNode,
			EvSearch: (s: Control, e: ValueChangedEventArgs) =>
			{
				this._FilterText = e.Value;
				this._Offset = 0;
				this._refreshList(this._filtersPanel.getFilterData());
			},
			EvHideSearch: () =>
			{
				this._Offset = 0;
				this._FilterText = null;
				this._refreshList(this._filtersPanel.getFilterData());
			},
			ShowSearchButton: true,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this)
			},
			EvFocusSearch: () =>
			{
			}
		});

		if (NP.isAdmin())
			this._topAppBar.addItem(new IconToggleButton({
				FontImage: NP.FontImages.add,
				Value: 'AddJudge',
				RK: 'AddJudge',
				EvClick: () => (new EditJudgeDialog({
					EvChanged: () => this.refresh()
				})).show()
			}));

		this._topAppBar.addItem(new IconToggleButton({
			FontImage: NP.FontImages.tune,
			Value: 'Filters',
			EvClick: (btn: IconToggleButton) =>
			{
				btn.setData(!btn.getData())
				this._filtersPanel.setIsVisible(!this._filtersPanel.getIsVisible());
				this.setWidth(this._Width);
			}
		}));


		this._dataWithFiltersNode = NP.createNode(this._judjeListNode, 'data-with-filters-container');

		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			ShowSettingsButton: NP.isAdmin(),
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('Name'),
				Width: '30%',
				PropertyContent: 'Name'
			}, {
				Content: NP.RM.getString('Country'),
				Width: '30%',
				PropertyContent: 'Country'
			}, {
				Content: NP.RM.getString('Rating'),
				PropertyContent: 'Rating',
				Width: '15%'
			}, !NP.isTha() && {
				Content: NP.RM.getString('Qualification'),
				PropertyContent: 'Qualification',
				Width: '15%'
			}, {
				Content: NP.RM.getString('BoutsCount'),
				PropertyContent: 'BoutsCount',
				Width: '15%'
			}],
			ShowPaginator: false,
			EvSortClick: (s: DataTable, e: any) =>
			{
				e.CanceSort = true;

				switch (e.Column)
				{
					case 0:
						this._filtersPanel.setSortValues('Name', e.Direction);
						this._refreshList(this._filtersPanel.getFilterData());
						break;
					case 1:
						this._filtersPanel.setSortValues('Country', e.Direction);
						break;
					case 2:
						this._filtersPanel.setSortValues('Rating', e.Direction);
						this._refreshList(this._filtersPanel.getFilterData());
						break;
					case 3:
						this._filtersPanel.setSortValues('Qualification', e.Direction);
						this._refreshList(this._filtersPanel.getFilterData());
						break;
					case 4:
						this._filtersPanel.setSortValues('BoutsCount', e.Direction);
						this._refreshList(this._filtersPanel.getFilterData());
						break;
				}
			},
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this._refreshList();
			},
			EvItemClick: (s: object, e: { Item: IJudgeListItem }) =>
			{
				this.showBattleList(e.Item.Judge);
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this._refreshList();
			},
			EvItemContextMenu: (s: any, e: { Event: any, Item: IJudgeListItem }) =>
			{
				if (NP.isAdmin())
				{
					let menu = new Menu({
						Items: [{
							FontImage: NP.FontImages.edit,
							RK: 'Edit',
							Value: 'Edit'
						}, {
							FontImage: NP.FontImages.delete,
							RK: 'Delete',
							Value: 'Delete'
						}],
						EvItemSelected: (s: Menu, event: { Item: any }) =>
						{
							switch (event.Item.getValue())
							{
								case 'Delete':
									ServerAPI.delet(`/judge/${e.Item.Judge.Id}`).then(() => this.refresh());
									break;
								case 'Edit':
									(new EditJudgeDialog({
										Judge: e.Item.Judge,
										EvChanged: () => this.refresh()
									})).show();
									break;
							}
						}
					});
					menu.showContextMenu(e.Event);
				}
			},
			EvSelectionChanged: () =>
			{
			},
			EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e)
		});

		this._filtersPanel = new JudgesFilterPanel({
			ParentNode: this._dataWithFiltersNode,
			Width: 280,
			EvFilterSortChanged: (sender: JudgesFilterPanel, args: IJudgeFiltersSort) => this._refreshList(args)
		});
	}

	showBattleList(judge: IJudge)
	{
		this._DrillDownMode = true;
		NP.hideNode(this._judjeListNode);

		this._drillDownPanel = new BattlesList({
			ParentNode: this._root,
			StartDash: 'Refereeing',
			DrillDownFilter: {
				JudgeId: judge.Id
			}
		});
		this._drillDownPanel.getTopAppBar().EvBackClick.add(() => {
			this._DrillDownMode = false;
			NP.showNode(this._judjeListNode);
			this._drillDownPanel.destroy();
			this._drillDownPanel = null;
		}, this)

		this._drillDownPanel.setWidth(this.getWidth());
		this._drillDownPanel.setHeight(this.getHeight());
		this._drillDownPanel.getTopAppBar().setShowBackButton(true)
		this._drillDownPanel.getTopAppBar().getMainButton().setIsVisible(false);
		this._drillDownPanel.getTopAppBar().setCaption(judge.FirstName + " " + judge.LastName);
		this._drillDownPanel.refresh();
	}

	_onScrolled(s: DataTable, e: any)
	{
		if (e.scroll > 0 && e.isSmall)
			this._topAppBar.addClass('top-app-bar--fixed-scrolled');
		else
			this._topAppBar.removeClass('top-app-bar--fixed-scrolled');
	}

	refresh()
	{
		this._refreshList();

		this._onScrolled(null, {
			scroll: 0,
			isSmall: this._dataTable.getIsSmall()
		});
	}

	_refreshList(args?: IJudgeFiltersSort)
	{
		this._dataTable.setRows([]);


		let format = {
			f: "0,0.00",
			m: '{{Value}}'
		};

		ServerAPI.post("/judge/items", {FilterText: this._FilterText, ...args}).then((judges: IJudge[]) =>
		{
			if (judges)
			{
				this._Judges = judges.map(el =>
				{
					let name = (el.LastName + ' ' + (el.FirstName ? el.FirstName : '')).trim();
					return {
						Judge: el,
						Id: el.Id,
						State: el.State || '',
						StateISO: el.StateISO || '',
						Image: null,
						Name: name,
						Country: el.CountryName,
						Region: el.Region ? el.Region : '',
						City: el.City ? el.City : '',
						Rating: el.Rating || el.Rating == 0 ? NP.applyFormat(el.Rating, format, 2) : "",
						Qualification: el.Qualification,
						BoutsCount: el.BoutsCount
					}
				});


				// this._dataTable.getRightPagButton().setEnabled(this._Judges.length == this._Count);
				// this._dataTable.updatePagCaption(`${this._Offset} - ${Math.min(this._Offset + this._Count, this._Judges.length)} ${NP.RM.getString("of")} ${this._Judges.length}`);
				// this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);
				// this._dataTable.setShowPaginator(this._Judges.length > this._Count);

				this._dataTable.setRows(this._Judges);

				if (args)
					switch (args.SortField)
					{
						case 'Name':
							this._dataTable.updateSortIndicator(0, args.SortDirection);
							break;
						case 'Country':
							this._dataTable.updateSortIndicator(1, args.SortDirection);
							break;
						case 'Rating':
							this._dataTable.updateSortIndicator(2, args.SortDirection);
							break;
						case 'Qualification':
							this._dataTable.updateSortIndicator(3, args.SortDirection);
							break;
						case 'BoutsCount':
							this._dataTable.updateSortIndicator(4, args.SortDirection);
							break;
					}
			}
		});
	}

	_getContentHeight()
	{
		return this._Height - this._topAppBar.getOffsetHeight();
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._getContentHeight();
		this._dataTable.setHeight(h);
		this._filtersPanel.setHeight(h);
		if (this._drillDownPanel)
			this._drillDownPanel.setHeight(h);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);


		if (this._drillDownPanel)
			this._drillDownPanel.setWidth(value);

		if (this._dataTable.getIsSmall())
		{
			this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

}